import {
	ASSIGNEE_TYPE as ASSIGNEE_FIELD_TYPE,
	MULTI_USER_CF_TYPE,
	PEOPLE_CF_TYPE,
	RESPONDERS_CF_TYPE as RESPONDERS_FIELD_TYPE,
	USER_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import {
	MULTIUSERPICKER_FIELD_TYPE,
	USERPICKER_FIELD_TYPE,
} from '@atlassian/jira-project-settings-apps-common/src/consts.tsx';
import type { AssociatedField, Field } from '../../types/layout-items.tsx';

export const isPeopleFieldInMultiMode = (field: AssociatedField | Field): boolean => {
	switch (field.type) {
		case USERPICKER_FIELD_TYPE:
		case ASSIGNEE_FIELD_TYPE:
		case USER_CF_TYPE:
			return false;

		case MULTIUSERPICKER_FIELD_TYPE:
		case MULTI_USER_CF_TYPE:
		case RESPONDERS_FIELD_TYPE:
			return true;

		default:
			return field.configuration && typeof field.configuration === 'object'
				? field.configuration.isMulti !== false
				: true;
	}
};

export const isPeopleFieldModal = (field: AssociatedField | Field): boolean =>
	field.type === PEOPLE_CF_TYPE;
